import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");

    if (!sessionId) {
      navigate("/admin/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        localStorage.setItem("jk_admin_token", res.data.session_token);
        setUser(res.data.user);
        window.history.replaceState({}, document.title, "/admin");
        navigate("/admin", { replace: true, state: { user: res.data.user } });
      } catch (e) {
        const msg = e?.response?.data?.detail || "Sign in failed. Please try again.";
        toast.error(msg);
        navigate("/admin/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen grid place-items-center bg-neutralbg" data-testid="auth-callback">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin text-navy mx-auto" />
        <p className="mt-4 text-sm text-gray-500">Signing you in…</p>
      </div>
    </div>
  );
}
